import findIndex from "lodash/findIndex";
import {TASK_ACTIONS} from "utils/constants";
import {formatTaskDetailsTopBanner} from "utils/valueFormatter.function";
import {TaskDetailActions} from "components/mytasks/AvailableActions.class";
import type {TaskDetailsNavigation} from "types/taskDetails";

/**
 * The header data of a task: what formatTaskDetailsTopBanner finds in the task, plus where the task
 * is in the list it was opened from - all of My tasks, the filtered tasks, or the selected ones.
 */
export const getTaskNavigation = (task: any, tasks: any, oneHandleOnly: boolean): TaskDetailsNavigation => {
    const response = formatTaskDetailsTopBanner(task);
    if (!task) {
        return response;
    }

    response.companyName = task.companyName;
    if (oneHandleOnly) {
        const tasksAreFiltered = tasks.filteredKeys.length !== 0;
        const localTasks = tasksAreFiltered ? tasks.filteredTasks : tasks.allTasks;
        response.currentTask = findIndex(localTasks, (x: any) => x.task.key === task.key) + 1;
        response.total = localTasks.length;
    } else {
        response.currentTask = tasks.selectedKeys.indexOf(task.key) + 1;
        response.total = tasks.selectedKeys.length;
    }

    return response;
};

/** The actions the task details page offers for a task, the move to the previous and next task included. */
export const getActionsForTask = (task: any, navigation: TaskDetailsNavigation, taskDetails: any, tasksWithPayment: any[]) => {
    const activeActions = new TaskDetailActions();
    if (!task) {
        return activeActions;
    }

    // map all from task
    activeActions.enableFromTaskDetail(task);

    if (task.isHandled) {
        activeActions.disableAll();
        activeActions.enable(TASK_ACTIONS.OPEN, TASK_ACTIONS.EMAIL);
    } else {
        // add open & postpone & email
        activeActions.enable(TASK_ACTIONS.OPEN, TASK_ACTIONS.EMAIL);

        // add attachment depending on task permission
        if (taskDetails.taskPermission?.allowUploadAttachment) {
            activeActions.enable(TASK_ACTIONS.ADD_ATTACHMENT);
        }

        if (task.preApprovedForPayment === false && tasksWithPayment.length > 0) {
            activeActions.enable(TASK_ACTIONS.APPROVE_BATCH);
        }
    }

    if (navigation.currentTask !== navigation.total) activeActions.enable(TASK_ACTIONS.NEXT_TASK);
    if (navigation.currentTask !== 1) activeActions.enable(TASK_ACTIONS.PREVIOUS_TASK);
    return activeActions;
};
